import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import '@fontsource-variable/outfit';
import '@fontsource-variable/jetbrains-mono';
import './themes/theme.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
